import { render, staticRenderFns } from "./SelfHelpTools.vue?vue&type=template&id=ef254c0e"
import script from "./SelfHelpTools.vue?vue&type=script&lang=js"
export * from "./SelfHelpTools.vue?vue&type=script&lang=js"
import style0 from "./SelfHelpTools.vue?vue&type=style&index=0&id=ef254c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports